import { Option$isNone } from 'gleam:gleam/option'
import * as opts from 'gleam:redraw_toastify/internal/options'
import * as toast from 'gleam:toastify/toast'

export function addIf(result, field, fieldName, mapper) {
  if (Option$isNone(field)) return result
  result[fieldName] = mapper ? mapper(field[0]) : field[0]
  return result
}

export function convertPosition(position) {
  if (!position) return
  if (toast.Position$isTopRight(position)) return 'top-right'
  if (toast.Position$isTopCenter(position)) return 'top-center'
  if (toast.Position$isTopLeft(position)) return 'top-left'
  if (toast.Position$isBottomRight(position)) return 'bottom-right'
  if (toast.Position$isBottomCenter(position)) return 'bottom-center'
  if (toast.Position$isBottomLeft(position)) return 'bottom-left'
}

export function convertType(type) {
  if (!type) return
  if (type instanceof toast.Info) return 'info'
  if (type instanceof toast.Success) return 'success'
  if (type instanceof toast.Warning) return 'warning'
  if (type instanceof toast.Error) return 'error'
}

export function convertAutoclose(autoclose) {
  if (!autoclose) return
  if (opts.Autoclose$isAutocloseBool(autoclose)) return autoclose.boolean
  if (opts.Autoclose$isAutocloseTimeout(autoclose)) return autoclose.timeout
}

export function convertCloseButton(button) {
  if (!button) return
  if (opts.CloseButton$isCloseButtonBool(button)) return button.boolean
  if (opts.CloseButton$isCloseButtonNode(button)) return button.node
}

export function convertDraggableDirection(direction) {
  if (!direction) return
  if (opts.DraggableDirection$isDraggableDirection(direction))
    return direction.axis
}

export function convertTheme(theme) {
  if (!theme) return
  if (opts.Theme$isTheme(theme)) return theme.value
}

export function convertStyle(style) {
  if (!style) return
  const styles = {}
  for (const [key, value] of style) styles[key] = value
  return styles
}
